/*
 * - SABBANG PAHAYA GAMANEEYAN -
 * Created on Mon Jan 30 2023 5:01:26 AM
 *
 * By Kapila Rathnayaka
 *
 * Copyright (c) 2023 Kayble Zone Private Limited - Colombo Sri Lanka
 * Contact : http://www.kayblezone.lk - kapilarathnayaka@outlook.com
 */

import React from "react";
import Col from "react-bootstrap/Col";
import Header from "./Header";
import Footer from "./Footer";
import SubSearch from "../search/subsearch";

let hidesearchBox = false;

class Layout extends React.Component {
  render() {
    return (
      <>
        <Header />

        {!hidesearchBox ? (
          <div>
            <SubSearch />
            <Col xs={12}>{this.props.children}</Col>
          </div>
        ) : (
          <Row className="justify-content-md-center">
            <Col xs={12}>{this.props.children}</Col>
          </Row>
        )}
        <Footer />
      </>
    );
  }
}

export default Layout;
